import { Column, DataType, InputType } from '@miq/catalog';

export type PSColumn = Pick<
  Column,
  'field' | 'dataType' | 'header' | 'inputType' | 'values' | 'lookupCategory' | 'required'
>;

export const COLUMNS: PSColumn[] = [
  { field: 'name', dataType: DataType.Text, header: 'Name', inputType: InputType.Text, required: true },
  {
    field: 'is_statistical',
    dataType: 'boolean',
    header: 'Statistical',
    inputType: InputType.Dropdown,
    required: true,
    values: [
      { key: true, value: 'Yes' },
      { key: false, value: 'No' },
    ],
  },
  {
    field: 'publishing_sector',
    dataType: DataType.Text,
    header: 'Publishing Sector',
    inputType: InputType.Dropdown,
    values: [
      { key: 'Office', value: 'Office' },
      { key: 'Industrial', value: 'Industrial' },
      { key: 'Retail', value: 'Retail' },
      { key: 'Life Science', value: 'Life Science' },
      { key: 'R&D', value: 'R&D' },
      { key: 'Medical Office', value: 'Medical Office' },
    ],
  },
  {
    field: 'publishing_group',
    dataType: DataType.Text,
    header: 'Publishing Group',
    inputType: InputType.Dropdown,
    values: [
      { key: 'Published Nationally', value: 'Published Nationally' },
      { key: 'Published Locally', value: 'Published Locally' },
      { key: 'Not Published', value: 'Not Published' },
    ],
  },
  { field: 'description', dataType: DataType.Text, header: 'Description', inputType: InputType.TextArea },
];

export const HIDE_CONTROLS = ['publishing_sector', 'publishing_group'];

//to show default control when user is not US Researcher
export const DEFAULT_CONTROLS: PSColumn[] = [
  { field: 'name', dataType: DataType.Text, header: 'Name', inputType: InputType.Text, required: true },
  { field: 'description', dataType: DataType.Text, header: 'Description', inputType: InputType.TextArea },
];
